import React from "react";
import Highlighter from "react-highlight-words";
import type { HighlighterProps } from "react-highlight-words";
import styles from "./styles.module.scss";

export const AppHighlighter = (props: HighlighterProps) => {
  return <Highlighter highlightClassName={styles.highlight} {...props} />;
};
